module.exports = __webpack_public_path__ + "img/icon_result_success.5236b660.png";